import { xxssList } from './social-xxss';
import { useId } from 'react';
import Enllac from 'components/3catinfo/Enllac';
import Icona from 'components/3catinfo/ui/Icona';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './social.module.scss';

const XarxaSocial = (props) => {
    const { urlPath, icon, alt, isPodcast, mida, mostraPodcast = false } = props;
    const url = props[urlPath];
    const showSocial = url && (!isPodcast || (isPodcast && mostraPodcast));

    return showSocial ? (
        <li>
            <Enllac href={url} novaFinestra={true} ariaLabel={alt}>
                <Icona
                    isBlanc={false}
                    mida={mida}
                    icona={icon}
                    alt={alt}
                    ariaHidden={false}
                    inline={true}
                    className={styles.iconaSocial}
                />
            </Enllac>
        </li>
    ) : (
        <></>
    );
};

const Social = (props) => {
    const { className, estil, mostraTitol = true } = props;
    const componentId = useId().replace(/:/g, '-');

    const stylesSocial = clsx({
        [styles.social]: true,
        [className]: !__isEmpty(className),
        [styles[estil]]: !__isEmpty(estil)
    });

    const styleHeader = clsx({
        [styles.xarxesHeader]: true,
        [styles[`${estil}-header`]]: !__isEmpty(estil)
    });

    return (
        <aside className={styles.contentXarxes} aria-labelledby={`xarxes-${componentId}`}>
            {mostraTitol && (
                <h2 id={`xarxes-${componentId}`} className={styleHeader}>
                    Troba&apos;ns a:
                </h2>
            )}

            <ul className={stylesSocial}>
                {Object.entries(xxssList).map(([key, value]) => (
                    <XarxaSocial
                        key={`xarxa-social-${key}`}
                        {...props}
                        urlPath={value.urlPath}
                        icon={value.icon}
                        alt={value.alt}
                        isPodcast={value.isPodcast}
                    />
                ))}
            </ul>
        </aside>
    );
};

export default Social;
